import { Route } from 'react-router';
import { ProjectEdit } from './views/Project';
import { TeamEdit } from './views/Team';
import { UserPreference } from './views/User';

const CustomRoutes = [
    <Route path="/project/:id/:name">
        {({ match }) => (
            <ProjectEdit resource="project" basePath="project" id={match.params.id} tab={match.params.name} />
        )}
    </Route>,
    <Route path="/team/:id/:name">
        {({ match }) => (
            <TeamEdit resource="team" basePath="team" id={match.params.id} tab={match.params.name} />
        )}
    </Route>,
    <Route path="/settings">
        <UserPreference />
    </Route>
];

export default CustomRoutes;